import '../../scss/pages/location.scss';
let map;
initMap() ;
function initMap() {
	var options = {
		center: { lat: -8.65014910640421, lng: 115.12941024554938},
		zoom: 14,
		// styles: [
		// 	{
		// 		elementType: "geometry",
		// 		stylers: [
		// 			{
		// 				color: "#2bc184",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		elementType: "labels.text.fill",
		// 		stylers: [
		// 			{
		// 				color: "#8ec3b9",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		elementType: "labels.text.stroke",
		// 		stylers: [
		// 			{
		// 				color: "#1a3646",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "administrative.country",
		// 		elementType: "geometry.stroke",
		// 		stylers: [
		// 			{
		// 				color: "#4b6878",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "administrative.land_parcel",
		// 		elementType: "labels.text.fill",
		// 		stylers: [
		// 			{
		// 				color: "#64779e",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "administrative.province",
		// 		elementType: "geometry.stroke",
		// 		stylers: [
		// 			{
		// 				color: "#4b6878",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "landscape.natural",
		// 		elementType: "geometry",
		// 		stylers: [
		// 			{
		// 				color: "#2bc184",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "poi",
		// 		elementType: "geometry",
		// 		stylers: [
		// 			{
		// 				color: "#1e805f",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "poi",
		// 		elementType: "labels.text.fill",
		// 		stylers: [
		// 			{
		// 				color: "#ffffff",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "poi",
		// 		elementType: "labels.text.stroke",
		// 		stylers: [
		// 			{
		// 				color: "#1d4e40",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "poi.park",
		// 		elementType: "geometry.fill",
		// 		stylers: [
		// 			{
		// 				color: "#277c57",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "poi.park",
		// 		elementType: "labels.text.fill",
		// 		stylers: [
		// 			{
		// 				color: "#3C7680",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "road",
		// 		elementType: "geometry",
		// 		stylers: [
		// 			{
		// 				color: "#319b72",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "road",
		// 		elementType: "labels.text.fill",
		// 		stylers: [
		// 			{
		// 				color: "#ffffff",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "road",
		// 		elementType: "labels.text.stroke",
		// 		stylers: [
		// 			{
		// 				color: "#21735c",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "road.highway",
		// 		elementType: "geometry",
		// 		stylers: [
		// 			{
		// 				color: "#2d7662",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "road.highway",
		// 		elementType: "geometry.stroke",
		// 		stylers: [
		// 			{
		// 				color: "#1a6149",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "road.highway",
		// 		elementType: "labels.text.fill",
		// 		stylers: [
		// 			{
		// 				color: "#ffffff",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "road.highway",
		// 		elementType: "labels.text.stroke",
		// 		stylers: [
		// 			{
		// 				color: "#22594b",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "transit",
		// 		elementType: "labels.text.fill",
		// 		stylers: [
		// 			{
		// 				color: "#98a5be",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "transit",
		// 		elementType: "labels.text.stroke",
		// 		stylers: [
		// 			{
		// 				color: "#1d2c4d",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "transit.line",
		// 		elementType: "geometry.fill",
		// 		stylers: [
		// 			{
		// 				color: "#283d6a",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "transit.station",
		// 		elementType: "geometry",
		// 		stylers: [
		// 			{
		// 				color: "#3a4762",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "water",
		// 		elementType: "geometry",
		// 		stylers: [
		// 			{
		// 				color: "#1d4d72",
		// 			},
		// 		],
		// 	},
		// 	{
		// 		featureType: "water",
		// 		elementType: "labels.text.fill",
		// 		stylers: [
		// 			{
		// 				color: "#4e6d70",
		// 			},
		// 		],
		// 	},
		// ],
	};
	//new map
	map = new google.maps.Map(document.getElementById("map"), options);
    //Array Marker 
	let markersData=JSON.parse(themeData.dataProperties);
	console.log(markersData);
	let markers=markersData;
    //loop thriught markers
    for(let i=0; i<markers.length;i++){
        addMarker(markers[i]);
    }

    function addMarker(props){
        let marker = new google.maps.Marker({
            position:props.coord,
            map:map,
            //icon: props.iconImage,
        });

        if(props.iconImage){
            //set icon image
            marker.setIcon(props.iconImage);
        }

        if(props.content){
            let infoWindow = new google.maps.InfoWindow({
                content:props.content
            });
            infoWindow.open(map,marker);
            marker.addListener('click',function(){
                infoWindow.open(map,marker);
            })
        }
    }
	//console.log(themeData.dataProperties);
	
}

